<template>
  <div
    class="text-center py-6 px-4"
  >
    <div class="inline-block mb-6">
      <img
        src="@/assets/images/report/export.svg"
        width="172"
        height="100"
        alt=""
      >
    </div>

    <div class="font-bold mb-1">
      {{ $i18nPresenter.t('Export your presentation') }}
      <a
        href=""
        class="text-link--primary"
        @click.prevent="$emit('handleShowResultsClick')"
      >
        {{ $i18nPresenter.t('here') }}</a>.
    </div>
  </div>
</template>

<script>

export default {
  props: {},
}
</script>

<style lang="scss" scoped>
</style>
